import React, { useState } from 'react';
import { IconButton, TableCell, TableRow } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import MoreVertIcon from '@mui/icons-material/MoreVert';

import { formatDateTime } from 'utils/date.utils';
import { ManualTag } from '../contact-management.types';
import TagItemMenu from './tag-item-menu';

interface Props {
  tag: ManualTag;
  handleOpenEditTagDialog(): void;
  handleOpenDeleteTagDialog(): void;
}

const TagItem: React.FC<Props> = ({
  tag,
  handleOpenEditTagDialog,
  handleOpenDeleteTagDialog
}) => {
  const { classes } = useStyles();
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const [menuOpen, setMenuOpen] = useState(false);

  const handleOpenMenu = (event: React.MouseEvent<HTMLElement>) => {
    setMenuOpen(true);
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setMenuOpen(false);
    setAnchorEl(null);
  };

  return (
    <>
      <TableRow hover className={classes.tableRow}>
        <TableCell className={classes.cell}>
          {tag.name}
        </TableCell>
        <TableCell className={classes.cell}>
          {formatDateTime(tag.createDate, 'Pp')}
        </TableCell>
        <TableCell className={classes.cell}>
          <IconButton size="small" onClick={handleOpenMenu}>
            <MoreVertIcon className={classes.icon} />
          </IconButton>
        </TableCell>
      </TableRow>

      {/* The menu for editing/deleting */}
      <TagItemMenu
        anchorEl={anchorEl}
        menuOpen={menuOpen}
        handleOpenEditTagDialog={handleOpenEditTagDialog}
        handleOpenDeleteTagDialog={handleOpenDeleteTagDialog}
        handleCloseMenu={handleCloseMenu}
      />
    </>
  );
};

const useStyles = makeStyles()((theme) => ({
  tableRow: {
    '&:hover': {
      backgroundColor: theme.palette.action.hover
    }
  },
  cell: {
    fontSize: theme.typography.pxToRem(13),
    padding: '8px 24px',
    // Remove default borders and use a custom one to match the new design
    border: 'none',
    borderBottom: `1px solid ${theme.palette.greys?.light || '#ddd'}`,
    verticalAlign: 'middle',
  },
  icon: {
    fontSize: theme.typography.pxToRem(18),
    color: theme.palette.greys?.medium || '#666',
  }
}));

export default TagItem;
